<template>
  <div class="ab_a-controls flex-1">
    <slot></slot>
    <div
      v-if="hasCapture"
      class="gw_btn gw_btn_tag flex-1 csst csst_nm"
      style="--clr: var(--clr-grey-2); --clr-hover: var(--clr-white-0); --height: 1.5rem"
      @click.stop="$emit('click:capture')"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
    >
      <i class="mdi mdi-camera text-medium" />
      <div
        class="csst_content clr-white text-nowrap"
        style="position: fixed"
        v-html="$t('tooltips.analyze_hand_screenshot')"
      ></div>
    </div>
    <div
      class="gw_btn gw_btn_tag flex-1 csst csst_nm"
      style="--clr: var(--clr-grey-2); --clr-hover: var(--clr-white-0); --height: 1.5rem"
      @click.stop="$emit('click:replay')"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
    >
      <i class="mdi mdi-video text-medium" />
      <div
        class="csst_content clr-white text-nowrap"
        style="position: fixed"
        v-html="$t('tooltips.replay_hand')"
      ></div>
    </div>

    <div
      v-if="!studyLinkDisabled && lastSpotLink"
      class="flex-1"
      @click.stop="$emit('click:study')"
    >
      <a
        target="_blank"
        :href="`${lastSpotLink}`"
        class="gw_btn gw_btn_tag flex-1 csst csst_nm"
        style="--clr: var(--clr-grey-2); --clr-hover: var(--clr-white-0); --height: 1.5rem"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
      >
        <i
          class="mdi mdi-school text-medium"
          style="color: currentColor"
        />
        <div
          class="csst_content clr-white text-nowrap"
          style="position: fixed"
          v-html="$t('tooltips.study_spot')"
        ></div>
      </a>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'
import { sendGaEvent } from '@gto/analytics/google-analytics'

export default {
  name: 'HaControls',
  mixins: [format_mix, links_mix, float_mix],
  props: {
    lastSpotLink: String,
    hasCapture: { type: Boolean, default: true },
    hasText: Boolean,
    studyLinkDisabled: Boolean,
  },
  emits: ['click:capture', 'click:replay', 'click:study'],
  methods: {
    sendGaEvent,
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_a-controls {
    display: flex;
    align-items: center;
    gap: 2px;
  }
}
</style>
